import { render } from "./app-icon-empty-placeholder.vue?vue&type=template&id=46dfafe9"
const script = {}

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__